function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    fillRule: "evenodd",
    d: "M18.283 5.856H3.289L7.685 1.77a.98.98 0 0 0 .259-.724.998.998 0 0 0-.342-.694C7.183-.013 6.536.023 6.18.413L.634 5.646c-.63.692-.63 1.734.019 2.447l5.511 5.191c.358.393 1.03.433 1.438.08a.992.992 0 0 0 .342-.692 1 1 0 0 0-.282-.75L3.289 7.861h14.994c2.573 0 4.667 2.048 4.667 4.567 0 2.518-2.094 4.565-4.667 4.565h-.941c-.562 0-1.022.451-1.022 1.004 0 .553.46 1.004 1.022 1.004h.941c3.7 0 6.71-2.949 6.71-6.573 0-3.624-3.01-6.572-6.71-6.572z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBack);
export default __webpack_public_path__ + "static/media/ico-back.f125aba2ccb87005103d2793080beb8e.svg";
export { ForwardRef as ReactComponent };